import { Fragment } from 'react';
function inline(text: string) {
  return text
    .split(/(\*\*[^*]+\*\*)/g)
    .map((part, i) =>
      part.startsWith('**') ? (
        <strong key={i}>{part.slice(2, -2)}</strong>
      ) : (
        <Fragment key={i}>{part}</Fragment>
      ),
    );
}
export function SafeMarkdown({ content, className }: { content: string; className?: string }) {
  return (
    <div className={className}>
      {content.split(/\n\s*\n/).map((block, i) => {
        const heading = block.match(/^#{1,3}\s+(.+)$/);
        if (heading) return <h3 key={i}>{inline(heading[1] ?? '')}</h3>;
        const lines = block.split('\n');
        if (lines.every((l) => /^[-*]\s+/.test(l)))
          return (
            <ul key={i}>
              {lines.map((l, j) => (
                <li key={j}>{inline(l.replace(/^[-*]\s+/, ''))}</li>
              ))}
            </ul>
          );
        return (
          <p key={i} style={{ whiteSpace: 'pre-wrap' }}>
            {inline(block)}
          </p>
        );
      })}
    </div>
  );
}
